import { call, takeLatest, all } from 'redux-saga/effects';
import { v1 } from 'uuid';

import {
  createRole,
  editRole,
  getRoles,
  getPlainRoles,
  deleteRole,
  getAdmins,
  createAdmin,
  editAdmin,
  deleteAdmin,
  bulkDeleteRoles,
  bulkDeleteAdmins,
} from 'api/administration';
import { ADMINISTRATION_ACTION_TYPES } from 'store/actions/administration.actions';

function* loadPlainRolesFlow(action) {
  const { resolve, reject } = action;
  try {
    const { data: response } = yield call(getPlainRoles);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* loadRolesFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(getRoles, payload);
    resolve({ items: data['hydra:member'], total: data['hydra:totalItems'] });
  } catch (e) {
    reject(e.response.data);
  }
}

function* createRoleFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(createRole, { ...payload, role: v1().replace(/-/g, '') });
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* editRoleFlow(action) {
  const { payload, resolve, reject } = action;
  const { id, ...data } = payload;
  try {
    const { data: response } = yield call(editRole, id, data);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* deleteRoleFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    if (Array.isArray(payload)) {
      const { data: response } = yield call(bulkDeleteRoles, payload);
      resolve(response);
    } else {
      const { data: response } = yield call(deleteRole, payload);
      resolve(response);
    }
  } catch (e) {
    reject(e.response.data);
  }
}

function* loadAdminsFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(getAdmins, payload);
    resolve({ items: data['hydra:member'], total: data['hydra:totalItems'] });
  } catch (e) {
    reject(e.response.data);
  }
}

function* createAdminFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(createAdmin, payload);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* editAdminFlow(action) {
  const { payload, resolve, reject } = action;
  const { id, password, ...data } = payload;
  try {
    data.admin = `/admins/${id}`;
    if (password) {
      data.password = password;
    }
    const { data: response } = yield call(editAdmin, data);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* deleteAdminFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    if (Array.isArray(payload)) {
      const { data: response } = yield call(bulkDeleteAdmins, payload);
      resolve(response);
    } else {
      const { data: response } = yield call(deleteAdmin, payload);
      resolve(response);
    }
  } catch (e) {
    reject(e.response.data);
  }
}

function* watchLoadRoles() {
  yield takeLatest(ADMINISTRATION_ACTION_TYPES.LOAD_ROLES, loadRolesFlow);
}

function* watchCreateRole() {
  yield takeLatest(ADMINISTRATION_ACTION_TYPES.CREATE_ROLE, createRoleFlow);
}

function* watchEditRole() {
  yield takeLatest(ADMINISTRATION_ACTION_TYPES.EDIT_ROLE, editRoleFlow);
}

function* watchDeleteRole() {
  yield takeLatest(ADMINISTRATION_ACTION_TYPES.DELETE_ROLE, deleteRoleFlow);
}

function* watchLoadPlainRoles() {
  yield takeLatest(ADMINISTRATION_ACTION_TYPES.LOAD_PLAIN_ROLES, loadPlainRolesFlow);
}

function* watchLoadAdmins() {
  yield takeLatest(ADMINISTRATION_ACTION_TYPES.LOAD_ADMINS, loadAdminsFlow);
}

function* watchCreateAdmin() {
  yield takeLatest(ADMINISTRATION_ACTION_TYPES.CREATE_ADMIN, createAdminFlow);
}

function* watchEditAdmin() {
  yield takeLatest(ADMINISTRATION_ACTION_TYPES.EDIT_ADMIN, editAdminFlow);
}

function* watchDeleteAdmin() {
  yield takeLatest(ADMINISTRATION_ACTION_TYPES.DELETE_ADMIN, deleteAdminFlow);
}

export default function* () {
  yield all([
    watchLoadRoles(),
    watchCreateRole(),
    watchEditRole(),
    watchDeleteRole(),
    watchLoadPlainRoles(),
    watchLoadAdmins(),
    watchCreateAdmin(),
    watchEditAdmin(),
    watchDeleteAdmin(),
  ]);
}
